import * as React from "react";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

type Props = {
  id: React.ReactText;
  closeAction: (key?: string | number | undefined) => void;
};

export const NotifierCloseAction: React.FC<Props> = props => {
  const handleDismiss = () => {
    props.closeAction(props.id);
  };

  return (
    <Button onClick={handleDismiss}>
      <CloseIcon />
    </Button>
  );
};
